export const spotLightMode_Closed = 'closed';
export const spotlightMode_Wizard = 'wizard';
export const spotlightMode_Disposition = 'disposition';
export const spotLightMode_PhysicianNotes = 'physician-notes';
export const spotlightMode_Survey = 'survey';
export const spotlightMode_Support = 'support';
export const spotlightMode_ResolveOrder = 'resolve-order';
export const spotlightMode_EditFindings = 'edit-findings';
export const spotlightModes = [
    spotLightMode_Closed,
    spotlightMode_Wizard,
    spotlightMode_Disposition,
    spotLightMode_PhysicianNotes,
    spotlightMode_Survey,
    spotlightMode_Support,
    spotlightMode_ResolveOrder,
    spotlightMode_EditFindings
];
//# sourceMappingURL=types.js.map